import { useTenant } from './tenant.tsx';
import { I18nProvider, getInitialLang } from './i18n.tsx';
import { Header } from './components/Header.tsx';
import { Services } from './components/Services.tsx';
import { SupportBubble } from './components/SupportBubble.tsx';

export function App() {
  const tenant = useTenant();
  return (
    <I18nProvider initialLang={getInitialLang(tenant.locale.defaultLang)}>
      <Header />
      <div id="root-content" className="max-w-7xl mx-auto p-4">
        <Services />
      </div>
      <SupportBubble />
    </I18nProvider>
  );
}
